import { call, put, takeLatest, takeEvery, take } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { eventChannel } from 'redux-saga'

import { fetchUserNotificationsHistorySuccess } from 'redux/modules/userNotificationsHistory';
import {
  FETCH_EVENT_LOG_ITEM_DIFF_SUCCESS, FETCH_EVENT_LOG_ITEM_SUCCESS,
} from 'redux/modules/eventLog';
import { recievePatientMessage } from 'redux/modules/patientsMessages';
import { GET_PATIENT_DOCUMENT_SUCCESS } from 'redux/modules/patientsDocuments';

// Actions
export const INITIALIZE_USER_NOTIFICATIONS = 'INITIALIZE_USER_NOTIFICATIONS';
export const INITIALIZE_USER_NOTIFICATIONS_SUCCESS = 'INITIALIZE_USER_NOTIFICATIONS_SUCCESS';
export const INITIALIZE_USER_NOTIFICATIONS_FAIL = 'INITIALIZE_USER_NOTIFICATIONS_FAIL';
export const REINITIALIZE_USER_NOTIFICATIONS = 'REINITIALIZE_USER_NOTIFICATIONS';
export const REINITIALIZE_USER_NOTIFICATIONS_SUCCESS = 'REINITIALIZE_USER_NOTIFICATIONS_SUCCESS';
export const REINITIALIZE_USER_NOTIFICATIONS_FAIL = 'REINITIALIZE_USER_NOTIFICATIONS_FAIL';
export const FETCH_USER_NOTIFICATIONS = 'FETCH_USER_NOTIFICATIONS';
export const FETCH_USER_NOTIFICATIONS_SUCCESS = 'FETCH_USER_NOTIFICATIONS_SUCCESS';
export const FETCH_USER_NOTIFICATIONS_FAIL = 'FETCH_USER_NOTIFICATIONS_FAIL';
export const GET_USER_NOTIFICATION_SUCCESS = 'GET_USER_NOTIFICATION_SUCCESS';
export const READ_USER_NOTIFICATIONS = 'READ_USER_NOTIFICATIONS';
export const READ_ALL_USER_NOTIFICATIONS = 'READ_ALL_USER_NOTIFICATIONS';

export let userNotificationsWebSocket;
let userNotificationsTriggerLoading = false;
let userNotificationsPush = false;
let userNotificationsPatientNotifications = false;
let userNotificationsFilteredByPatient = false;

// Reducer
export default function userNotificationsReducer(state = {
  data: [], count: 0, loading: 0, initialized: false,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case INITIALIZE_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        ...{ initialized: true },
      };
    case FETCH_USER_NOTIFICATIONS:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_USER_NOTIFICATIONS_SUCCESS:
      if (userNotificationsPush) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.Notifications.slice(0, payload.data.length),
        ];
        return {
          ...state,
          data: newData,
          ...userNotificationsTriggerLoading ? { loading: state.loading - 1 } : {},
          count: payload.data['Full Count'],
          filterCount: payload.data['Filter Count'],
        };
      }
      if (userNotificationsPatientNotifications) {
        return {
          ...state,
          data: state.data.map((dataItem) => {
            if (dataItem.Patient['Record Number'] === payload.data.Notifications[0].Patient['Record Number']) {
              return {
                ...dataItem,
                'Patient Notifications': payload.data.Notifications.slice(1),
              };
            }
            return dataItem;
          }),
        };
      }
      if (userNotificationsFilteredByPatient) {
        return {
          ...state,
          data: [{
            ...payload.data.Notifications[0],
            Count: payload.data.Notifications.length,
            'Patient Notifications': payload.data.Notifications.slice(1),
          }],
          ...userNotificationsTriggerLoading ? { loading: state.loading - 1 } : {},
          count: payload.data['Full Count'],
          filterCount: payload.data['Filter Count'],
        };
      }
      return {
        ...state,
        data: payload.data.Notifications,
        ...userNotificationsTriggerLoading ? { loading: state.loading - 1 } : {},
        count: payload.data['Full Count'],
        filterCount: payload.data['Filter Count'],
      };
    case FETCH_USER_NOTIFICATIONS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case GET_USER_NOTIFICATION_SUCCESS:
      let notificationPatientPresent = false;
      const newData = state.data.reduce((accumulator, dataItem) => {
        if (dataItem.Patient['Record Number'] === payload.data.Patient['Record Number']) {
          notificationPatientPresent = true;
          const prevDataItem = Object.assign({}, dataItem);
          return [
            {
              ...dataItem,
              ...payload.data,
              Count: dataItem.Count + 1,
              realTime: true,
              'Patient Notifications': [
                prevDataItem,
                ...dataItem['Patient Notifications'] ? [...dataItem['Patient Notifications']] : [],
              ],
            },
            ...accumulator,
          ];
        }
        return [
          ...accumulator,
          dataItem,
        ];
      }, []);
      return {
        ...state,
        data: [
          ...!notificationPatientPresent ? [{
            ...payload.data,
            Count: 1,
            realTime: true,
          }] : [],
          ...newData,
        ],
        count: state.count + 1,
        filterCount: state.filterCount + 1,
      };
    case READ_USER_NOTIFICATIONS:
      return {
        ...state,
        data: state.data.map(dataItem => ({
          ...dataItem,
          ...payload.ID.indexOf(dataItem.ID) !== -1 ? { 'Has Read': true } : {},
          ...dataItem['Patient Notifications'] ? {
            'Patient Notifications': dataItem['Patient Notifications'].map(patientItem => ({
              ...patientItem,
              ...payload.ID.indexOf(patientItem.ID) !== -1 ? { 'Has Read': true } : {},
            })),
          } : {},
        })),
        count: state.count - payload.ID.length < 0 ? 0 : state.count - payload.ID.length,
        filterCount: state.filterCount - payload.ID.length < 0 ? 0 : state.filterCount - payload.ID.length,
      };
    case READ_ALL_USER_NOTIFICATIONS:
      return {
        ...state,
        filterCount: 0,
      };
    case FETCH_EVENT_LOG_ITEM_DIFF_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.Notification['Diff ID'] !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          Notification: {
            ...dataItem.Notification,
            Diff: payload,
          },
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case FETCH_EVENT_LOG_ITEM_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.Notification['Event Log ID'] !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          Notification: {
            ...dataItem.Notification,
            EventLog: payload,
          },
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case GET_PATIENT_DOCUMENT_SUCCESS: {
      const newData = state.data.map((dataItem) => ({
        ...dataItem,
        ...dataItem.Meta['Document ID'] && dataItem.Meta['Document ID'] === payload.ID ? {
          Meta: {
            ...dataItem.Meta,
            ...payload,
          },
        } : {},
        ...dataItem['Patient Notifications'] ? { 'Patient Notifications': dataItem['Patient Notifications'].map(patientNotificationsItem => ({
          ...patientNotificationsItem,
          ...patientNotificationsItem.Meta['Document ID'] && patientNotificationsItem.Meta['Document ID'] === payload.ID ? {
            Meta: {
              ...patientNotificationsItem.Meta,
              ...payload,
            },
          } : {},
        }))} : {},
      }));
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function initializeUserNotifications(payload) {
  return { type: INITIALIZE_USER_NOTIFICATIONS, payload };
}

export function initializeUserNotificationsSuccess(payload) {
  return { type: INITIALIZE_USER_NOTIFICATIONS_SUCCESS, payload };
}

export function initializeUserNotificationsFail(payload) {
  return { type: INITIALIZE_USER_NOTIFICATIONS_FAIL, payload };
}

export function reinitializeUserNotifications(payload) {
  return { type: REINITIALIZE_USER_NOTIFICATIONS, payload };
}

export function reinitializeUserNotificationsSuccess(payload) {
  return { type: REINITIALIZE_USER_NOTIFICATIONS_SUCCESS, payload };
}

export function reinitializeUserNotificationsFail(payload) {
  return { type: REINITIALIZE_USER_NOTIFICATIONS_FAIL, payload };
}

export function fetchUserNotifications(payload) {
  return { type: FETCH_USER_NOTIFICATIONS, payload };
}

export function fetchUserNotificationsSuccess(payload) {
  return { type: FETCH_USER_NOTIFICATIONS_SUCCESS, payload };
}

export function fetchUserNotificationsFail(payload) {
  return { type: FETCH_USER_NOTIFICATIONS_FAIL, payload };
}

export function getUserNotificationSuccess(payload) {
  return { type: GET_USER_NOTIFICATION_SUCCESS, payload };
}

export function readUserNotifications(payload) {
  return { type: READ_USER_NOTIFICATIONS, payload };
}

export function readAllUserNotifications(payload) {
  return { type: READ_ALL_USER_NOTIFICATIONS, payload };
}

// Requests

export function requestGenerateUserToken(payload) {
  return callApi('security/gen_user_token/', 'POST', payload);
}

// Sagas
function* initializeUserNotificationsSaga({ type }) {
    const res = yield call(requestGenerateUserToken);
    if (res.data.token) {
      const channel = yield call(watchInitializeUserNotificationsChannel, {
        token: res.data.token,
        reinitialize: type === REINITIALIZE_USER_NOTIFICATIONS,
      });
      while (true) {
        const action = yield take(channel);
        yield put(action);
      }
    }
}

function* watchInitializeUserNotificationsChannel(query) {
  return eventChannel(emitter => {
    const hostname = window.location.hostname === 'localhost' ? 'test02.dme4dme.com' : window.location.hostname;

    userNotificationsWebSocket = new WebSocket(
      `wss://${hostname}/ws/notifications/?token=${query.token}`
    );

    userNotificationsWebSocket.addEventListener('open', (event) => {
      // console.log('WebSocket opened');
      if (query.reinitialize) {
        emitter(reinitializeUserNotificationsSuccess());
      } else {
        emitter(initializeUserNotificationsSuccess());
      }
    });

    userNotificationsWebSocket.addEventListener('error', (event) => {
      console.log('WebSocket error: ', event);
      setTimeout(() => {
        emitter(reinitializeUserNotifications());
      }, 1000);
    });

    userNotificationsWebSocket.addEventListener('close', (event) => {
      console.log('WebSocket closed');
      setTimeout(() => {
        emitter(reinitializeUserNotifications());
      }, 1000);
    });

    userNotificationsWebSocket.addEventListener('message', (event) => { 
      const data = JSON.parse(event.data);
      // console.log('WebSocket message: ');
      // console.log(data);
      if (data.ID) {
        if (data.type === 'info' && data.Subject === 'patient' && data['Sub Subject'] === 'patient_sms') {
          emitter(recievePatientMessage({
            'Date of Creation': data['Create At'],
            ID: data.ID,
            // Media: {}
            Message: data.Meta.Message,
            'Patient ID': data.Patient['Record Number'],
            Sender: 'Patient',
            User: data.Author,
          }));
        } else {
          emitter(getUserNotificationSuccess({
            data,
          }));
        }
      } else if (data.Notifications) {
        if (userNotificationsWebSocket.loadingNotifications) {
          userNotificationsWebSocket.loadingNotifications = false;
          emitter(fetchUserNotificationsSuccess({
            data,
          }));
        }
        if (userNotificationsWebSocket.loadingNotificationsHistory) {
          userNotificationsWebSocket.loadingNotificationsHistory = false;
          emitter(fetchUserNotificationsHistorySuccess({
            data,
          }));
        }
      }  
    });

    return () => {};
  });
  
}

function* fetchUserNotificationsSaga(action) {
  const { triggerLoading, patientNotifications, push = false, filters, limit, offset } = action.payload;
  if (triggerLoading) {
    userNotificationsTriggerLoading = triggerLoading;
  }
  if (patientNotifications) {
    userNotificationsPatientNotifications = true;
  } else {
    userNotificationsPatientNotifications = false;
  }
  if (filters && filters['Patient ID']) {
    userNotificationsFilteredByPatient = true;
  } else {
    userNotificationsFilteredByPatient = false;
  }
  userNotificationsPush = push;
  userNotificationsWebSocket.loadingNotifications = true;
  userNotificationsWebSocket.send(JSON.stringify({
    load_notifications: {
      ...filters && filters.length > 0 ? { filters } : {},
      limit,
      offset,
    },
  }));
}

function* readUserNotificationsSaga(action) {
  const { ID } = action.payload;
  // console.log('Read Notifications:');
  // console.log(ID);
  userNotificationsWebSocket.send(JSON.stringify({
    mark_as_read: {
      event_log_ids: ID,
    },
  }));
}

function* readAllUserNotificationsSaga(action) {
  const { filters } = action.payload;
  userNotificationsWebSocket.send(JSON.stringify({
    filter_mark_as_read : {
      filters,
    },
  }));
}

export function* userNotificationsSaga() {
  yield takeLatest(INITIALIZE_USER_NOTIFICATIONS, initializeUserNotificationsSaga);
  yield takeLatest(REINITIALIZE_USER_NOTIFICATIONS, initializeUserNotificationsSaga);
  yield takeLatest(FETCH_USER_NOTIFICATIONS, fetchUserNotificationsSaga);
  yield takeEvery(READ_USER_NOTIFICATIONS, readUserNotificationsSaga);
  yield takeEvery(READ_ALL_USER_NOTIFICATIONS, readAllUserNotificationsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/userNotifications.js